import {createApi} from '@reduxjs/toolkit/query/react';
import {customBaseQueryWithCaptcha} from '~/common/rtk-query/queries';

export const api = createApi({
  reducerPath: 'event',
  baseQuery: customBaseQueryWithCaptcha({basePath: '/ajax'}),
  tagTypes: ['Event'],
  endpoints: () => ({}),
});
